import React, { useLayoutEffect } from "react";
import Footer from "../../components/Layout/Footer";
import SiteBreadcrumb from "../../components/Common/Breadcumb";
import ServiceDetailsContent from "./ServiceDetailsContent";
import breadcrumbsImg from "../../assets/img/breadcrumbs/2.jpg";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const ServiceDetails = () => {
  const { id } = useParams();
  const services = useSelector((state) => state.data.service);
  const service = services.find((s) => s._id === id);
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  if (!service) return <p className="text-center mt-5">Service not found</p>;

  return (
    <React.Fragment>
      {/* breadcrumb-area-start */}
      <SiteBreadcrumb
        breadcrumbsImg={breadcrumbsImg}
        // pageTitle="Software Development"
        pageTitle={service.title}
        // pageCategory="Services"
        // pageName={page.title}
      />

      <ServiceDetailsContent service={service} />

      <Footer footerClass="rs-footer" />

      {/* <SearchModal /> */}
    </React.Fragment>
  );
};

export default ServiceDetails;
